// import { useEffect, useState } from 'react';
//
// interface IUseSmoothHeight {
//     contentRef: React.RefObject<HTMLDivElement>;
//     isCollapsed: boolean;
//     children: React.ReactNode;
// }
//
// export const useSmoothHeight = ({ contentRef, isCollapsed, children }: IUseSmoothHeight) => {
//     const [contentHeight, setContentHeight] = useState('0px');
//
//     useEffect(() => {
//         const updateHeight = () => {
//             if (contentRef.current) {
//                 setContentHeight(isCollapsed ? '0px' : `${contentRef.current.scrollHeight}px`);
//             }
//         };
//
//         const observer = new ResizeObserver(updateHeight);
//         if (contentRef.current) {
//             observer.observe(contentRef.current);
//         }
//
//         updateHeight();
//
//         return () => {
//             if (contentRef.current) {
//                 observer.unobserve(contentRef.current);
//             }
//         };
//     }, [isCollapsed, children]);
//
//     return { contentHeight };
// };
import React, { useEffect, useRef, useState } from 'react';

interface IUseSmoothHeight {
    contentRef: React.RefObject<HTMLDivElement>;
    isCollapsed: boolean;
    children: React.ReactNode;
}

export const useSmoothHeight = ({ contentRef, isCollapsed, children }: IUseSmoothHeight) => {
    const [contentHeight, setContentHeight] = useState('0px');
    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;

        const updateHeight = () => {
            if (contentRef.current) {
                const newHeight = isCollapsed ? '0px' : `${contentRef.current.scrollHeight}px`;
                if (newHeight !== contentHeight) {
                    requestAnimationFrame(() => {
                        if (isMounted.current) {
                            setContentHeight(newHeight);
                        }
                    });
                }
            }
        };

        const observer = new ResizeObserver(updateHeight);
        if (contentRef.current) {
            observer.observe(contentRef.current);
        }

        updateHeight();

        return () => {
            isMounted.current = false;
            observer.disconnect();
        };
    }, [isCollapsed, children, contentHeight, contentRef]);

    return { contentHeight };
};
